import React from 'react';

export const SlidesConfig = {
	'1.31.0': [
		{
			image: require('./assets/race-finder.png').default,
			imageMobile: require('./assets/race-finder-mobile.png').default,
			title: 'Revamped Racing Platform',
			content: (
				<>
					Ultra-intuitive navigation with everything
					<br />
					at your fingertips. Now featuring Race Finder
					<br />
					to jump to any race in 2 taps.
				</>
			),
			footer: (
				<div className=" _flex _items-center _justify-center  _py-6">
					<img width={50} height={50} src={require('./assets/race-finder.svg').default} />
				</div>
			),
		},
		{
			image: require('./assets/form.png').default,
			imageMobile: require('./assets/form-mobile.png').default,
			title: 'New and Improved Form Guide',
			content: (
				<>
					Including easy glance key stats,
					<br /> speed maps and more!
				</>
			),
			footer: (
				<div className=" _flex _items-center _justify-center  _py-6">
					<img width={50} height={50} src={require('./assets/form.svg').default} />
				</div>
			),
		},
		{
			image: require('./assets/speed-map.png').default,
			imageMobile: require('./assets/speed-map-mobile.png').default,
			title: 'Enhanced Speed',
			content: (
				<>
					Lightning-fast app to ensure you
					<br /> never miss the jump.
				</>
			),
			footer: (
				<div className=" _flex _items-center _justify-center  _py-6">
					<img width={50} height={50} src={require('./assets/speed-map.svg').default} />
				</div>
			),
		},
	],
};
